module.exports = __webpack_public_path__ + "static/img/btn_rule.e7a82a7a.png";